import { render, staticRenderFns } from "./UploadCutter.vue?vue&type=template&id=f2e415f4";
import script from "./UploadCutter.vue?vue&type=script&lang=js";
export * from "./UploadCutter.vue?vue&type=script&lang=js";
import style0 from "./UploadCutter.vue?vue&type=style&index=0&id=f2e415f4&prod&lang=less";

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js";
var component = normalizer(script, render, staticRenderFns, false, null, null, null);
export default component.exports;